export default __webpack_public_path__ + "static/media/no-work-order-keys-icon.58d296e8.svg";